import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advanced from 'dayjs/plugin/advancedFormat';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import { DateTime } from 'luxon';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advanced);
dayjs.extend(quarterOfYear);

export function dayjsToStringDate(date: Dayjs) {
  return date.format('YYYY-MM-DD');
}

export function today(timezoneArg?: string) {
  return dayjs().tz(timezoneArg || "America/Chicago").startOf("day").format("YYYY-MM-DD");
}

export function addDaysToDate(date: string, days: number): string {
  return dayjs(date).add(days, 'days').format('YYYY-MM-DD');
}

export function addMonthsToDate(date: string, months: number): string {
  return dayjs(date).add(months, 'months').format('YYYY-MM-DD');
}

export function subtractDates(date: string, dateTwo: string): number {
  return dayjs(date).diff(dateTwo, 'day');
}

export function formatDateForPreview(date?: string) {
  if (!date) {
    return '';
  }

  return dayjs(date).format('MM/DD/YYYY');
}
export function serializeDateToString(date?: Date) {
  return dayjs(date).format('YYYY-MM-DD');
}

export function formatDatetimeAsTimeForElog(dateTime?: string, timezoneArg?: string) {
  if (!dateTime) {
    return '';
  }
  return DateTime.fromISO(dateTime)
    .setZone(timezoneArg || 'America/Chicago')
    .toFormat('HH:mm:ss');
}

export function formatTimeForPreview(dateTime?: string, timezoneArg?: string) {
  if (!dateTime) {
    return '';
  }

  return DateTime.fromISO(dateTime)
    .setZone(timezoneArg || 'America/Chicago')
    .toFormat('h:mma');
}


export function formatDatetimeForPreview(dateTime?: string, timezoneArg?: string) {
  if (!dateTime) {
    return '';
  }

  return DateTime.fromISO(dateTime)
    .setZone(timezoneArg || 'America/Chicago')
    .toFormat('MM/dd/yy h:mma');
}

export function formatTimeAsHourMin(decimal: number) {
  const diff = decimal - Math.floor(decimal);
  if (diff > 0 && 1 - diff < 0.00001) {
    decimal = Math.ceil(decimal);
  }
  const hours = Math.floor(decimal);

  const minutes = Math.min(59, Math.round((decimal - hours) * 60));

  // Format hours and minutes
  const formattedHours = hours < 10 ? `0${hours}` : hours;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

  // Return the time in HH:mm format
  return `${formattedHours}:${formattedMinutes}`;
}

export function getCurrentYear(): number {
  return dayjs().year();
}

export function getCurrentQuarter(): number {
  return dayjs().quarter();
}

export function generateYearRange(startYearsBack: number = 25, futureYears: number = 5): number[] {
  const currentYear = dayjs().year();
  const startYear = currentYear - startYearsBack;
  const endYear = currentYear + futureYears;

  return Array.from({ length: endYear - startYear + 1 }, (_, i) => endYear - i);
}

export function getQuarterStartDate(year: number, quarter: number): string {
  return dayjs().year(year).quarter(quarter).startOf('quarter').format('YYYY-MM-DD');
}

export function getQuarterEndDate(year: number, quarter: number): string {
  return dayjs().year(year).quarter(quarter).endOf('quarter').format('YYYY-MM-DD');
}

export function formatQuarterForPreview(year: number, quarter: number): string {
  return `Q${quarter} ${year}`;
}


export const daylightSavingsChange = function() {
  const changes = new Map<string, string>();
  changes.set("2025-11-02", "2025-11-02T01:00:00");
  return changes;
}();